var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.819 8.571A1.786 1.786 0 1011 6.82a1.786 1.786 0 001.819 1.752zm5.724 13.516A1.457 1.457 0 1020 23.543a1.458 1.458 0 00-1.457-1.456zm0 1.913a.457.457 0 11.457-.457.457.457 0 01-.457.457zm4-1.913A1.457 1.457 0 1024 23.543a1.458 1.458 0 00-1.457-1.456zm0 1.913a.457.457 0 11.457-.457.457.457 0 01-.457.457zm-2.2-7A1.342 1.342 0 1019 15.658 1.342 1.342 0 0020.342 17zm-2.775-.375v4.128a.938.938 0 001.206.899l2.606-.776.526.606a.623.623 0 00.942-.816l-1.215-1.4a.623.623 0 00-.879-.063.613.613 0 00-.156.214l-2.03-2.068v-.724A1.626 1.626 0 0016.943 15h-.87a.5.5 0 000 1h.87a.626.626 0 01.625.625zm-2.394 2.73l-1.527-2.233.377-4.298.408.76a.613.613 0 00.426.338l1.564.421a.623.623 0 00.321-1.204l-1.327-.357-1.434-2.668a1.74 1.74 0 00-3.274.64l-.396 4.49a1.736 1.736 0 00.396 1.283l-.233 2.707-3.548 2.104a.893.893 0 10.905 1.54l.004-.002 3.938-2.355a.869.869 0 00.444-.68l.126-1.46 1.198 1.75-.003 3.975a.895.895 0 001.79.03v-4.241a.886.886 0 00-.155-.54z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--easy-access-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'EasyAccessCircleIcon';
export default Icon;